Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};

let GlobalHelper = function () {
    /**
    * Cambia la hora en Date() para que BD lo guarde correctamente y no con +3 hs.
    * @param {any} date
    */
    function _dateBD() {
        let hora = Date.now() - 10800000;
        let horaParaBD = new Date(hora);
        return horaParaBD
    }

    function formateoMensajeError(msjError){ 
        if(msjError != undefined){
            if(msjError.includes("One or more errors occurred.")){
                msjError = msjError.replace("One or more errors occurred.","");
            }
            if(msjError.includes("({")){
                msjError = msjError.replace("({","");
            }
            if(msjError.includes("})")){
                msjError = msjError.replace("})","");
            }
            while(msjError.includes('"')){
                msjError = msjError.replace('"',"");
            }
        }    
        return msjError.trim();
    }

    /**
     * Convierte un numero de documento
     * @param {any} numeroDocumentoAconvertir
     * @param {any} tipoDocumento
     */
    function _convertirNumeroDocumento(numeroDocumentoAconvertir, tipoDocumento) {
        let resultado;
        switch (tipoDocumento) {
            case "CUIT":
                resultado = convertirCuilCuitCie(numeroDocumentoAconvertir);
                break;
            case "CUIL":
                resultado = convertirCuilCuitCie(numeroDocumentoAconvertir);
                break;
            case "CIE":
                resultado = convertirCuilCuitCie(numeroDocumentoAconvertir);
                break;
            case "DNI":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "LE":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "LC":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "CI":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "PTE":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
            case "CD":
                resultado = convertirDniLeLcCiPteCd(numeroDocumentoAconvertir);
                break;
        }
        return resultado;
    }


    /**
     * Convierte un numero de documento al formato correspondiente (CUIL-CUIT-CIE)
     * @param {any} numeroCuilCuitCie
     */
    function convertirCuilCuitCie(numeroCuilCuitCie) {
        let num = (numeroCuilCuitCie) ? numeroCuilCuitCie.toString() : "";
        return num.substring(2, 0) + '-' + num.substring(num.length - 1, 2) + '-' + num.substring(num.length - 1);
    }

    /**
     * Convierte un numero de documento al formato correspondiente (DNI-LE-LC-CI-PTE-CD)
     * @param {any} numeroDniLeLcCiPteCd
     */
    function convertirDniLeLcCiPteCd(numeroDniLeLcCiPteCd) {
        let num = (numeroDniLeLcCiPteCd) ? numeroDniLeLcCiPteCd.toString().replace(/\./g, '') : "";
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
        }
        return num;
    }

    /**
     * Convierte un numero con el formato miles y millones con decimales incorporados en parametro
     * @param {any} numeroConDecimales
     */
    function _convertirNumeroConDecimales(numeroConDecimales) {
        let limites = (numeroConDecimales) ? numeroConDecimales.toString() : "";
        let enterosLimite = limites.substring(0, limites.length - 2);
        let decimalesLimite = limites.substring(limites.length - 2, limites.length);

        let numeroAconvertir = enterosLimite.toString();
        let num = numeroAconvertir.replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');

            if (num.substring(0, 2) === "-.") {
                num = num.substring(0, 1) + num.substring(2, num.length);
            }
        }

        return num + ',' + decimalesLimite;
    }

    /**
     * Depende de la seleccion puede convierte un numero con el formato miles y millones con decimales no incorporados en parametro ó
       convertir un numero con el formato miles y millones
     * @param {any} seleccion
     * @param {any} numeroSinDecimales
     */
    function _convertirNumeroSinDecimales(seleccion, numeroSinDecimales) {
        let patron = new RegExp(/\./g);

        if (!patron.test(numeroSinDecimales)) {
            let num = (numeroSinDecimales) ? numeroSinDecimales.toString().replace(/\./g, '') : "";
            if (numeroSinDecimales == 0) {
                num = numeroSinDecimales;
            }
            else {
                if (!isNaN(num)) {
                    num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
                    num = num.split('').reverse().join('').replace(/^[\.]/, '');

                    if (num.substring(0, 2) === "-.") {
                        num = num.substring(0, 1) + num.substring(2, num.length);
                    }
                }
            }

            return seleccion == 0 ? num + ",00" : num
        }
        return numeroSinDecimales;
    }

    /**
     * Depende de la seleccion puede convierte un numero con el formato miles y millones con decimales incorporados
       en caso de no tener decimales se los agregará (",00") 
     * @param {any} numeroSinDecimales
     */
    function _conversionDeMilesAgregandoDecimales(numeroSinDecimales) {
        let patron = new RegExp(/\./g);
        let decimal = ",00";
        let numAux; 
        
        if (numeroSinDecimales != undefined && numeroSinDecimales != "" && numeroSinDecimales != null) {
            if (numeroSinDecimales.toString().includes(",")) {
                numAux = numeroSinDecimales.toString().split(",");
                numeroSinDecimales = numAux[0].toString();
                decimal = "," + numAux[1];
                if (decimal.length == 2)
                    decimal = decimal + "0";
            }
            if (numeroSinDecimales.toString().includes(".")) {
                numAux = numeroSinDecimales.toString().split(".");
                numeroSinDecimales = numAux[0].toString();
                decimal = "," + numAux[1];
                if (decimal.length == 2)
                    decimal = decimal + "0";
            }

            if (!patron.test(numeroSinDecimales)) {
                let num = (numeroSinDecimales) ? numeroSinDecimales.toString().replace(/\./g, '') : "";
                if (numeroSinDecimales == 0) {
                    num = numeroSinDecimales;
                }
                else {
                    if (!isNaN(num)) {
                        num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g, '$1.');
                        num = num.split('').reverse().join('').replace(/^[\.]/, '');

                        if (num.substring(0, 2) === "-.") {
                            num = num.substring(0, 1) + num.substring(2, num.length);
                        }
                    }
                }

                return num + decimal
            }
        }
        else{
            numeroSinDecimales = "0"
        }
        
        return numeroSinDecimales + decimal;
    }

    /**
    * Elimina decimales
    * @param {any} numeroAeliminarDecimales
    */
    function _eliminarDecimales(numeroAeliminarDecimales) {
        let num = (numeroAeliminarDecimales) ? numeroAeliminarDecimales.toString() : "";
        return num.substring(0, num.toString().length - 2);
    }

    /**
    * Formatea fechas
    * @param {any} date
    */
    function _formatDate(date) {
        
    
        var dd = date.getDay().toString().length = 2 ? date.getDay().toString() : '0' + date.getDay().toString();
        var mm = (date.getMonth()+1).toString().length = 2 ? (date.getMonth()+1).toString() : '0' + (date.getMonth()+1).toString();
        var yyyy = date.getFullYear().toString();

        newDate = dd + '/' + mm + '/' + yyyy;

        return newDate;
    }

    function _obtenerLimitesEmpresaCliente(empresas, novedades, cliente) {
        const { LimiteAsignado, LimitePorCuit, LimiteSinAsignar } = cliente;

        let limiteAsignadoAux = 0;

        empresas.filter(e0 => e0.SolicitudEstado != 11 && e0.SolicitudEstado != 4).forEach((e, ei) => {
            if (e.esNueva == true) {
                limiteAsignadoAux += parseFloat(e.LimiteCompra);
            } else {
                let novedad = novedades.find(n => n.NovedadCampoCodigo == "LIMCO_EMPR" && (n.EmpresaVisaId == e.Id || n.EmpresaId == e.Id));

                if (novedad) {
                    limiteAsignadoAux += parseFloat(novedad.ValorNovedad);
                } else {
                    limiteAsignadoAux += parseFloat(e.LimiteCompra);
                }
            }
        });

        return {
            LimitePorCuit,
            LimiteAsignado: limiteAsignadoAux,
            LimiteSinAsignar: (LimitePorCuit - limiteAsignadoAux)
        }
    }

    /**
    * Compara una fecha mayor o igual al del dia de hoy
    * @param {any} date (Formato: DD/MM/YYYY)
    */
    function _compararFechaDeHoy(date) {
        let dateParts = date.split("/");
        let newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        let dateNow = new Date().toISOString().slice(0, 19).replace('T', ' ').slice(0, 10).split("-");
        let paramDate = new Date(dateNow[0], dateNow[1] - 1, dateNow[2]);
        let actualDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        let fecha = newDate.toISOString().slice(0, 19).replace('T', ' ');
        let estado = false;
        if (paramDate <= actualDate) {
            estado = true;
        }

        return {
            estado: estado,
            fecha: fecha
        }
    }

    /**
    * Completa con 2 decimales
    * @param {any} numero
    */
    function _completarDecimales(numero) {
        let nroFinal;
        let limites = (numero) ? numero.toString() : "";

        if (limites.indexOf('.') > 0) {
            let nroSplit = limites.split('.');

            switch (nroSplit[1].length) {
                case 0:
                    nroFinal = limites + '.00';
                    break;
                case 1:
                    nroFinal = nroSplit[0] + '.' + nroSplit[1] + '0';
                    break;
                case 2:
                    nroFinal = limites;
                default:
            }
        }
        else {
            nroFinal = limites + '.00';
        }

        return nroFinal;
    }

    function _convertirFecha(fecha, string, local) {
        if(typeof(fecha) == "string" && fecha.includes("/")){
            let fechaAux = fecha.split('/')
            let fecha1 = ""
            let fecha2 = ""
            let dia = fechaAux[0].length > 1 ? fechaAux[0] : "0" + fechaAux[0]
            let mes = fechaAux[1].length > 1 ? fechaAux[1] : "0" + fechaAux[1]
            fecha1 += mes + "/" + dia + "/" + fechaAux[2]
            fecha2 += dia + "/" + mes + "/" + fechaAux[2]

            if (string && !local) return fecha1
            if (string && local) return fecha2

            return new Date(fecha1);
        }else{
            return fecha;
        }
    }

    function _convertirFechaDB(fecha, soloFecha) {
        let objFecha = new Date(fecha)
        let fechaAux = objFecha.toLocaleString();
        if(soloFecha) fechaAux = objFecha.toLocaleDateString();
        return fechaAux;        
    }

    function _checkDateType(fecha) {
        let tipo = typeof(fecha);
        let fechaAux

        if(tipo == "object") return fecha.toLocaleDateString();
        if(tipo == "string"){
            if(fecha.includes("T")){
                fechaAux = new Date(fecha)
                return fechaAux.toLocaleDateString();
            }
        }
        return fecha  
    }

    function _ordenarArrayPorFecha(array, propiedadFecha){
        return array.sort((a, b) => new Date(b[propiedadFecha]) - new Date(a[propiedadFecha]))
    }

    function _calcularDiferenciaDias(fecha1,fecha2){
        let f1= new Date(fecha1);
        let f2 = new Date(fecha2);

        return parseInt(((f2 - f1) / (1000 * 3600 * 24)))
    }

    function _fechaVencida(fecha1, formatoLocal) {
        
       let fecha1Aux = fecha1;
      
       if(formatoLocal){
           fecha1Aux = fecha1.split("/");
           fecha1Aux = fecha1Aux[1]+"/"+fecha1Aux[0]+"/"+fecha1Aux[2];
       }

       fecha1Aux = new Date(fecha1Aux);
    
       return fecha1Aux <  new Date();       
    }

    return {
        FechaVencida: function (fecha1, formatoLocal) {
            return _fechaVencida(fecha1, formatoLocal);
        },
        CalcularDiferenciaDias: function (fecha1,fecha2) {
            return _calcularDiferenciaDias(fecha1,fecha2);
        },
        OrdenarArrayPorFecha: function (array, propiedadFecha) {
            return _ordenarArrayPorFecha(array, propiedadFecha);
        },
        ConvertirFecha: function (fecha, string, local) {
            return _convertirFecha(fecha, string, local);
        },
        ConvertirFechaDB: function (fecha, soloFecha) {
            return _convertirFechaDB(fecha, soloFecha);
        },
        CheckDateType: function (fecha, soloFecha) {
            return _checkDateType(fecha);
        },
        ConvertirNumeroDocumento: function (numeroDocumentoAconvertir, tipoDocumento) {
            return _convertirNumeroDocumento(numeroDocumentoAconvertir, tipoDocumento);
        },
        DateBD: function () {
            return _dateBD();
        },

        ConvertirNumeroConDecimales: function (numeroConDecimales) {
            return _convertirNumeroConDecimales(numeroConDecimales);
        },

        ConvertirNumeroSinDecimales: function (numeroSinDecimales) {
            return _convertirNumeroSinDecimales(0, numeroSinDecimales);
        },

        ConversionDeMilesAgregandoDecimales: function (numeroSinDecimales) {
            return _conversionDeMilesAgregandoDecimales(numeroSinDecimales);
        },

        ConvertirNumeroMilesMillones: function (numeroMilesMillones) {
            return _convertirNumeroSinDecimales(1, numeroMilesMillones);
        },

        EliminarDecimales: function (numeroAeliminarDecimales) {
            return _eliminarDecimales(numeroAeliminarDecimales);
        },

        FormatDate: function (date) {
            return _formatDate(date);
        },

        CompararFechaDeHoy: function (date) {
            return _compararFechaDeHoy(date);
        },

        ObtenerLimitesEmpresaCliente: function (empresas, novedades, cliente) {
            return _obtenerLimitesEmpresaCliente(empresas, novedades, cliente);
        },

        CompletarDecimales: function (numero) {
            return _completarDecimales(numero);
        },

        ParseFloat: function (num) {
            return parseFloat((num + "").replace(/^(.*\.\d\d)\d*$/, '$1'))
        },

        formateoMensajeError: function (msjError) {
            return formateoMensajeError(msjError);
        },
        
        FormatearLimite: function (valor) {
            if (isNaN(valor)) {
                return "0,00";
            } else {
                if (Number.isInteger(valor)) {
                    return _convertirNumeroSinDecimales(0, valor);
                } else {
                    return _convertirNumeroConDecimales(valor);
                }
            }
        }
    }
}

let globalHelper = new GlobalHelper();
export default globalHelper;